import { initialState } from '../schema';

export const reduceReadUserSessionRequest = (state) => ({
  ...state,
  ui: { ...state.ui, isFetchingSession: true },
});

// sets user session data
export const reduceReadUserSessionSuccess = (state, { payload }) => ({
  ...state,
  base: { ...state.base, ...payload },
  ui: { ...state.ui, hasCheckedSession: true, isFetchingSession: false },
});

export const reduceReadUserSessionFailure = (state) => ({
  ...initialState,
  nextRouteLocation: state?.nextRouteLocation ?? '',
  ui: {
    ...state.ui,
    hasCheckedSession: true,
  },
});
